// import BigCommerceSearch from './searches/BigCommerceSearch.js'
// import ShopifySearch from './searches/ShopifySearch.js'
// import WordPressSearch from './searches/WordPressSearch.js'
import { AlgoliaSearch } from './searches/AlgoliaSearch.js';
// import SearchSpringSearch from './searches/SearchSpringSearch.js'

const ProcessSearch = async (searchTerm, limit = 100, facetFilters = {}) => {
  const resultPromises = [];

  // resultPromises.push(BigCommerceSearch(searchTerm, limit));
  // resultPromises.push(ShopifySearch(searchTerm, limit));
  // resultPromises.push(WordPressSearch(searchTerm, limit));

  resultPromises.push(AlgoliaSearch(searchTerm, limit, facetFilters));
  const results = await Promise.all(resultPromises);
  return { ...results };
};

export default ProcessSearch;
